// import React, { useEffect, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// import * as S from "./TransducerGoogleChirp1.style";
// import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
// import ZaiaSelect from "../../../../zaiaComponents/zaiaSelect";
// import * as P from "../../../../../utils/pipes";
// import TranducerMessagesList from "../tranducerMessagesList";
// import useInfoToken from "../../../../../hooks/useInfoToken";

// const record = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/record.svg`;
// const talkingHead = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/talking-head.svg`;
// const talkingHeads = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/talking-heads.svg`;

// const BASE_WS_URL =
//   "wss://transcriptor-rest-server-54644131242.us-central1.run.app/transcribe";
  

// function TransducerGoogleChirp1({
//   transducerTypes,
//   transducerType,
//   setTransducerType,
//   recordingActived,
//   setRecordingActived,
//   transducerState,
//   setTransducerState,
//   setManageTransductionActiveConfirmation,
//   messages,
//   setMessages,
//   transcription,
//   setTranscription
// }) {
//   const { t, i18n: { language } } = useTranslation("global");
//   const { token } = useInfoToken();

//   const [interimText, setInterimText] = useState("");

//   const mediaStreamRef = useRef(null);
//   const socketRef = useRef(null);
//   const isUserStoppedRef = useRef(true);

//   const audioContextRef = useRef(null);
//   const processorRef = useRef(null);
//   const inputRef = useRef(null);

//   /* 🔥 Warm-up */
//   useEffect(() => {
//     setTransducerType(1);
//     setTransducerState(null);
//     stopRecording();

//     const warmUp = async () => {
//       try {
//         const httpUrl = BASE_WS_URL
//           .replace("wss://", "https://")
//           .replace("/transcribe", "/");
//         await fetch(httpUrl);
//         await fetch(httpUrl);
//       } catch (e) {
//         console.warn("Error despertando servidor", e);
//       }
//     };

//     warmUp();
//     return () => stopRecording();
//   }, []);

//   /* =======================
//      🔌 SOCKET
//   ======================= */

//   const connectSocket = (lang) => {
//     if (isUserStoppedRef.current) return;

//     const socket = new WebSocket(`${BASE_WS_URL}?lang=${lang}`);
//     socketRef.current = socket;

//     socket.onopen = () => {
//       setTransducerState("listening");
//     };

//     socket.onmessage = (event) => {
//       const data = JSON.parse(event.data);

//       if (data.error) {
//         console.error("Server Error:", data.error);
//         setTransducerState("error");
//         return;
//       }

//       if (data.is_final) {
//         setTranscription(prev => prev + data.text + " ");
//         setInterimText("");
//       } else {
//         setInterimText(data.text);
//       }
//     };

//     socket.onclose = () => {
//       if (!isUserStoppedRef.current) {
//         setTimeout(() => connectSocket(lang), 500);
//       }
//     };

//     socket.onerror = (err) => {
//       console.error("WebSocket Error:", err);
//       setTransducerState("error");
//     };
//   };

//   /* =======================
//      🎧 AUDIO
//   ======================= */

//   const floatTo16BitPCM = (input) => {
//     const buffer = new ArrayBuffer(input.length * 2);
//     const view = new DataView(buffer);

//     for (let i = 0; i < input.length; i++) {
//       let s = Math.max(-1, Math.min(1, input[i]));
//       view.setInt16(i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true);
//     }
//     return buffer;
//   };

//   const processAudioStream = () => {
//     const audioContext = new AudioContext({ sampleRate: 16000 });
//     audioContextRef.current = audioContext;

//     const input = audioContext.createMediaStreamSource(mediaStreamRef.current);
//     inputRef.current = input;

//     const processor = audioContext.createScriptProcessor(4096, 1, 1);
//     processorRef.current = processor;

//     input.connect(processor);
//     processor.connect(audioContext.destination);

//     processor.onaudioprocess = (e) => {
//       if (socketRef.current?.readyState === WebSocket.OPEN) {
//         const channelData = e.inputBuffer.getChannelData(0);
//         socketRef.current.send(floatTo16BitPCM(channelData));
//       }
//     };
//   };

//   /* =======================
//      ▶️ START
//   ======================= */

//   const startRecordingNoteTaking = async () => {
//     try {
//       isUserStoppedRef.current = false;

//       const simpleLang = P.languageSplited(language);

//       let lang = "en-US";

//       if (simpleLang === "es") {
//         lang = "es-US";
//       } else if (simpleLang === "fr") {
//         lang = "fr-FR";
//       } else if (simpleLang === "pt") {
//         lang = "pt-BR";
//       }

//       const stream = await navigator.mediaDevices.getUserMedia({
//         audio: { channelCount: 1, sampleRate: 16000 }
//       });

//       mediaStreamRef.current = stream;

//       setTransducerState("connecting");
//       connectSocket(lang);
//       processAudioStream();

//     } catch (err) {
//       console.error("Error al iniciar grabación:", err);
//       setTransducerState("error");
//     }
//   };

//   /* =======================
//      ⏹️ STOP
//   ======================= */

//   const stopRecording = () => {
//     isUserStoppedRef.current = true;

//     if (interimText) {
//       setTranscription(prev => prev + interimText + " ");
//       setInterimText("");
//     }

//     processorRef.current?.disconnect();
//     inputRef.current?.disconnect();
//     audioContextRef.current?.close();

//     if (socketRef.current) socketRef.current.close();
//     if (mediaStreamRef.current) {
//       mediaStreamRef.current.getTracks().forEach(track => track.stop());
//     }

//     setTransducerState("paused");
//   };

//   const finalizeSession = () => {
//     setManageTransductionActiveConfirmation(true);
//     stopRecording();
//   };

//   /* =======================
//      🖼️ UI
//   ======================= */

//   return (
//     <S.TransducerGoogleChirp1 modelsSelection={P.languageSplited(language) === "en"}>
//       <div className="transducer-content">
//         {recordingActived && (
//           <div className="messages-wrapper">
//             <TranducerMessagesList
//               transducerState={transducerState}
//               transducerType={transducerType}
//               transcription={
//                 transcription + (interimText ? `...${interimText}` : "")
//               }
//               messages={messages}
//             />
//           </div>
//         )}

//         {!recordingActived && (
//           <TransductorChooseType
//             transducerTypes={transducerTypes}
//             transducerType={transducerType}
//             setTransducerType={setTransducerType}
//           />
//         )}
//       </div>

//       <div className="space-start-recording">
//         {transducerState === null && (
//           <button
//             className="recording-button"
//             onClick={() => {
//               if (transducerType) {
//                 setRecordingActived(true);
//                 startRecordingNoteTaking();
//               }
//             }}
//           >
//             <div className="recording-button__text">
//               {t("transductor.startSession")}
//             </div>
//             {transducerType ? (
//               <div className="recording-button__circle" />
//             ) : (
//               <i className="recording-button__icon icon zaia-i-lock-chat" />
//             )}
//           </button>
//         )}

//         {transducerState !== null && (
//           <div className="active-recording-buttons">
//             {transducerState === "listening" && (
//               <button
//                 className="recording-button recording-button--pause"
//                 onClick={stopRecording}
//               >
//                 <i className="recording-button__icon recording-button__icon--pause icon zaia-i-paused" />
//               </button>
//             )}

//             {(transducerState === "paused" ||
//               transducerState === "error") && (
//               <button
//                 className="recording-button recording-button--continue"
//                 onClick={() => {
//                   setRecordingActived(true);
//                   startRecordingNoteTaking();
//                 }}
//               >
//                 <div className="recording-button__text">
//                   {t("globally.continue")}
//                 </div>
//                 <div className="recording-button__circle" />
//               </button>
//             )}

//             <button
//               className={`recording-button recording-button--finish ${
//                 (transcription || messages.length > 0) &&
//                 "recording-button--finish--active"
//               }`}
//               onClick={() =>
//                 (transcription || messages.length > 0) && finalizeSession()
//               }
//             >
//               {t("transductor.finalizeSession")}
//             </button>
//           </div>
//         )}
//       </div>
//     </S.TransducerGoogleChirp1>
//   );
// }

// /* =======================
//    🧩 SELECT TYPE
// ======================= */

// function TransductorChooseType({
//   transducerType,
//   setTransducerType,
//   transducerTypes
// }) {
//   const { t } = useTranslation("global");

//   return (
//     <div className="transducer-choose-type">
//       <div className="message-space">
//         <div className="message-space__title">
//           {t("transductor.advancedNoteTaking")}
//         </div>

//         {transducerType === 1 && (
//           <img
//             src={talkingHead}
//             alt="note"
//             className="message-space__img--note-taking"
//           />
//         )}

//         {transducerType === 2 && (
//           <img
//             src={talkingHeads}
//             alt="consult"
//             className="message-space__img--medical-consultation"
//           />
//         )}

//         {!transducerType && (
//           <img
//             src={record}
//             alt="record"
//             className="message-space__img--start"
//           />
//         )}

//         <div className="message-space__text">
//           {!transducerType
//             ? t("transductor.selectAMode")
//             : transducerTypes.find(t => t.id === transducerType)?.description}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TransducerGoogleChirp1;




import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./TransducerGoogleChirp1.style";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import ZaiaSelect from "../../../../zaiaComponents/zaiaSelect";
import * as P from "../../../../../utils/pipes";
import TranducerMessagesList from "../tranducerMessagesList";
import useInfoToken from "../../../../../hooks/useInfoToken";

// [NUEVO] Importación del Modal base
import Modal from "../../../../../utils/modal";

const record = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/record.svg`;
const talkingHead = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/talking-head.svg`;
const talkingHeads = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaFigures/talking-heads.svg`;

const BASE_WS_URL = "wss://transcriptor-rest-server-54644131242.us-central1.run.app/transcribe";
const BASE_API_URL = "https://transcriptor-rest-server-54644131242.us-central1.run.app";

function TransducerGoogleChirp1({
  transducerTypes,
  transducerType,
  setTransducerType,
  recordingActived,
  setRecordingActived,
  transducerState,
  setTransducerState,
  setManageTransductionActiveConfirmation,
  messages,
  setMessages,
  transcription,
  setTranscription
}) {
  const { t, i18n: { language } } = useTranslation("global");
  const { token } = useInfoToken();

  const [interimText, setInterimText] = useState("");
  const [diarizationProcess, setDiarizationProcess] = useState(false);

  const mediaStreamRef = useRef(null);
  const socketRef = useRef(null);
  const isUserStoppedRef = useRef(true);

  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  const inputRef = useRef(null);

  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [transcription, interimText, messages]);

  /* 🔥 Warm-up original */
  useEffect(() => {
    setTransducerType(1);
    setTransducerState(null);
    stopRecording();

    const warmUp = async () => {
      try {
        const httpUrl = BASE_WS_URL.replace("wss://", "https://").replace("/transcribe", "/");
        await fetch(httpUrl);
        await fetch(httpUrl);
      } catch (e) {
        console.warn("Error despertando servidor", e);
      }
    };

    warmUp();
    return () => stopRecording();
  }, []);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log("App en segundo plano → pausar transcripción");
        stopRecording();
      } else {
        console.log("App volvió → reanudar transcripción");
        setRecordingActived(true);
        startRecordingNoteTaking();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  /* ============================================================
     [NUEVO] LÓGICA DE CARGA DE ARCHIVO (DIARIZACIÓN)
     ============================================================ */
  const handleFileUpload = async (event) => {

    setDiarizationProcess(true)

    const file = event.target.files[0];
    if (!file) return;

    setRecordingActived(true);
    setTransducerState("connecting"); 

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(`${BASE_API_URL}/diarize`, {
        method: 'POST',
        body: formData
      });
      const data = await response.json();

      if (data.status === "success") {
        setMessages(data.transcript); 
        setTranscription(data.transcript.map((message) => message.persona + ": " + message.mensaje).join(" \n"));
        setTransducerState("paused"); 
      } else {
        setTransducerState("error");
      }
    } catch (err) {
      console.error("Error en diarización:", err);
      setTransducerState("error");
    }
  };

  /* =======================
      🔌 SOCKET
  ======================= */
  const connectSocket = (lang) => {
    if (isUserStoppedRef.current) return;
    const socket = new WebSocket(`${BASE_WS_URL}?lang=${lang}`);
    socketRef.current = socket;
    socket.onopen = () => setTransducerState("listening");
    socket.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.error) { setTransducerState("error"); return; }
      if (data.is_final) {
        setTranscription(prev => prev + data.text + " ");
        setInterimText("");
      } else { setInterimText(data.text); }
    };
    socket.onclose = () => { if (!isUserStoppedRef.current) setTimeout(() => connectSocket(lang), 500); };
    socket.onerror = (err) => { setTransducerState("error"); };
  };

  /* =======================
      🎧 AUDIO
  ======================= */
  const floatTo16BitPCM = (input) => {
    const buffer = new ArrayBuffer(input.length * 2);
    const view = new DataView(buffer);
    for (let i = 0; i < input.length; i++) {
      let s = Math.max(-1, Math.min(1, input[i]));
      view.setInt16(i * 2, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
    return buffer;
  };

  const processAudioStream = () => {
    const audioContext = new AudioContext({ sampleRate: 16000 });
    audioContextRef.current = audioContext;
    const input = audioContext.createMediaStreamSource(mediaStreamRef.current);
    inputRef.current = input;
    const processor = audioContext.createScriptProcessor(4096, 1, 1);
    processorRef.current = processor;
    input.connect(processor);
    processor.connect(audioContext.destination);
    processor.onaudioprocess = (e) => {
      if (socketRef.current?.readyState === WebSocket.OPEN) {
        const channelData = e.inputBuffer.getChannelData(0);
        socketRef.current.send(floatTo16BitPCM(channelData));
      }
    };
  };

  /* =======================
      ▶️ START
  ======================= */
  const startRecordingNoteTaking = async () => {
    try {
      isUserStoppedRef.current = false;
      const simpleLang = P.languageSplited(language);
      let lang = simpleLang === "es" ? "es-US" : "en-US";
      const stream = await navigator.mediaDevices.getUserMedia({
        audio: { channelCount: 1, sampleRate: 16000 }
      });
      mediaStreamRef.current = stream;
      setTransducerState("connecting");
      connectSocket(lang);
      processAudioStream();
      monitorAudioContext();
    } catch (err) { setTransducerState("error"); }
  };

  const monitorAudioContext = () => {
    const interval = setInterval(() => {
      if (!audioContextRef.current) return;

      if (audioContextRef.current.state === "suspended") {
        console.log("🔥 AudioContext suspendido (probable llamada)");
        handleInterruption();
        clearInterval(interval);
      }
    }, 1000);
  };

  const handleInterruption = () => {
    if (isUserStoppedRef.current) return;

    console.log("⚠️ Interrupción detectada");

    stopRecording();

    // opcional: marcar estado especial
    setTransducerState("interrupted");
  };

  /* =======================
      ⏹️ STOP
  ======================= */
  const stopRecording = () => {
    isUserStoppedRef.current = true;
    if (interimText) {
      setTranscription(prev => prev + interimText + " ");
      setInterimText("");
    }
    processorRef.current?.disconnect();
    inputRef.current?.disconnect();

    if (audioContextRef.current?.state !== "closed") {
      audioContextRef.current?.close();
    }

    if (socketRef.current) socketRef.current?.close();
    
    if (mediaStreamRef.current) {
      mediaStreamRef.current?.getTracks().forEach(track => track.stop());
    }
    setTransducerState("paused");
  };

  const finalizeSession = () => {
    setManageTransductionActiveConfirmation(true);
    stopRecording();
  };

  /* =======================
      🖼️ UI
  ======================= */
  return (
    <S.TransducerGoogleChirp1 modelsSelection={P.languageSplited(language) === "en"}>
      <div className="transducer-content" ref={contentRef}>
        {recordingActived ? (
          <div className="messages-wrapper">
            <TranducerMessagesList
              transducerState={transducerState}
              transducerType={transducerType}
              transcription={transcription + (interimText ? `...${interimText}` : "")}
              messages={messages}
            />
          </div>
        ) : (
          <TransductorChooseType
            transducerTypes={transducerTypes}
            transducerType={transducerType}
            setTransducerType={setTransducerType}
          />
        )}
      </div>

      <div className="space-start-recording">
        {/* [AJUSTE] Mostramos el modo DUAL (Cargar/Empezar) siempre que no haya una sesión de grabación iniciada */}
        {!recordingActived ? (
          <div className="dual-action-buttons">
            <input
              type="file"
              accept="audio/*"
              onChange={handleFileUpload}
              style={{ display: 'none' }}
              id="audio-upload-input"
            />
            <button 
              className="btn-upload-audio" 
              onClick={() => document.getElementById('audio-upload-input').click()}
            >
              {t("transductor.uploadAudio")}
              <i className="icon zaia-i-upload btn-upload-audio__icon" />
            </button>

            <button
              className="recording-button"
              onClick={() => {
                if (transducerType) {
                  setRecordingActived(true);
                  startRecordingNoteTaking();
                }
              }}
            >
              <div className="recording-button__text">{t("transductor.startSession")}</div>
              {transducerType ? (
                <div className="recording-button__circle" />
              ) : (
                <i className="recording-button__icon icon zaia-i-lock-chat" />
              )}
            </button>
          </div>
        ) : (
          /* [CONTROLES] Se muestran una vez que se inició la grabación o se subió el archivo */
          <div className="active-recording-buttons">
            {transducerState === "listening" && (
              <button className="recording-button recording-button--pause" onClick={stopRecording}>
                <i className="recording-button__icon recording-button__icon--pause icon zaia-i-paused" />
              </button>
            )}

            {(transducerState === "paused" || transducerState === "error") && !diarizationProcess && (
              <button className="recording-button recording-button--continue" onClick={() => {
                setRecordingActived(true);
                startRecordingNoteTaking();
              }}>
                <div className="recording-button__text">{t("globally.continue")}</div>
                <div className="recording-button__circle" />
              </button>
            )}

            <button
              className={`recording-button recording-button--finish ${(transcription || messages.length > 0) && "recording-button--finish--active"}`}
              onClick={() => (transcription || messages.length > 0) && finalizeSession()}
            >
              {t("transductor.finalizeSession")}
            </button>
          </div>
        )}
      </div>
    </S.TransducerGoogleChirp1>
  );
}

function TransductorChooseType({ transducerType, setTransducerType, transducerTypes }) {
  const { t } = useTranslation("global");
  return (
    <div className="transducer-choose-type">
      <div className="message-space">
        <div className="message-space__title">{t("transductor.advancedNoteTaking")}</div>
        {transducerType === 1 && <img src={talkingHead} alt="note" className="message-space__img--note-taking" />}
        {transducerType === 2 && <img src={talkingHeads} alt="consult" className="message-space__img--medical-consultation" />}
        {!transducerType && <img src={record} alt="record" className="message-space__img--start" />}
        <div className="message-space__text">
          {!transducerType ? t("transductor.selectAMode") : transducerTypes.find(t => t.id === transducerType)?.description}
        </div>
      </div>
    </div>
  );
}

export default TransducerGoogleChirp1;
